import './info.scss';
import InfoIcon from '../../../assets/icons/UI/icons/info.svg';

interface InfoProps {
  text: string
}

const Info = (props: InfoProps) => {
  const {
    text
  } = props;

  return <span className={'info'}>
    <img
      src={InfoIcon}
      alt={'info'}
      className={'info-icon'}
    />
    <div className={'info-text'} dangerouslySetInnerHTML={{__html: text}}/>
  </span>
}

export default Info;